var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dashboard-header"},[_vm._v(_vm._s(_vm.$t('monthlyResults', { month: _vm.month })))]),_c('div',{attrs:{"id":"info-dashboard"}},_vm._l((_vm.blocksToDisplay),function(block,i){return _c('InfoBlock',{key:i,attrs:{"header":block.header,"info":block.info,"unit":block.unit,"footer":block.footer}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }